// Action Types
export const SET_TRANSLATION = 'SET_TRANSLATION';

// Action Creators
export const setTranslation = (key, data) => ({
  type: SET_TRANSLATION,
  payload: { key, data }
});